module.exports = __webpack_public_path__ + "static/media/right-angle.dbad795a.svg";